import get from 'lodash/get';
import toString from 'lodash/toString';
import { isDefined } from '~/types/typeGuards';

export const ensureDefinedItems = <T>(arr: (T | null | undefined)[]): T[] => {
  return arr.filter(isDefined);
};

type ObjDictionary<T> = Record<string, T | undefined>;

export const keyBy = <T>(items: T[], fieldPath: keyof T | `${string}.${string}`) =>
  items.reduce<ObjDictionary<T>>((acc, item) => {
    const val = get(item, fieldPath, null);
    if (!val) return acc;
    acc[toString(val)] = item;
    return acc;
  }, {});
